const assets = {}

assets.install = (Vue) => {
  Vue.prototype.$assets = {
    logo: {
      normal: require('@/assets/logo.svg'),
      white: require('@/assets/logo-white.svg')
    },
    favicon: {
      normal: require('@/assets/logo-desktop.svg'),
      white: require('@/assets/logo-desktop.svg')
    },
    robot: {
      normal: 'https://layrz-production.s3-us-west-2.amazonaws.com/resources/roberto-robato/normal.svg',
      white: 'https://layrz-production.s3-us-west-2.amazonaws.com/resources/roberto-robato/white.svg'
    },
    // background: 'https://layrz-production.s3-us-west-2.amazonaws.com/resources/background/primary.png',
    sidebar: {
      // background: 'https://layrz-production.s3-us-west-2.amazonaws.com/resources/background/fav-primary.png'
    },

    carMarker: require('@/assets/car.svg'),
    mapMarker: require('@/assets/map-marker.svg')
  }
}

export default assets
